import NoAudio from '@/constant/noAudio'
import { slideType } from '@/constant/allSlideTypes'

// state
const _state = {
  isSlideTypeNoAudio: false,
}

// getters
const _getters = {
  isSlideTypeNoAudio: (_, __, rootState) => {
    const { slideTypes } = NoAudio
    return slideTypes.includes(rootState.slideActive.type)
  },

  isContentSlide: (_, __, rootState) => {
    return rootState.slideActive && rootState.slideActive.type === slideType.freeStyle
  },
}

// mutations
const mutations = {

}

// actions
const actions = {

}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  mutations,
  actions,
}
